import template from './template';
import styles from './template.css';
import {AoflElement, customElement, property} from '@aofl/element';

/**
 * @summary AoflForm
 * @extends {AoflElement}
 */
@customElement('aofl-form')
class AoflForm extends AoflElement {
  /**
   *
   * @readonly
   */
  static is = 'aofl-form';

   connectedCallback() {
    super.connectedCallback();
    this.addEventListener('mousedown', function() {
      this.classList.remove('using-keyboard');
    });

    // Re-enable focus styling when Tab is pressed
    this.addEventListener('keyup', function(event) {
      if (event.code === 'Tab') {
        this.classList.add('using-keyboard');
      }
    });
   }

  disconnectedCallback() {
    this.removeEventListener('mousedown', this.keydownHandler);
    this.removeEventListener('keyup', this.listChangeHandler);
    super.disconnectedCallback();
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default AoflForm;
